import {CMODELS_EMPTY, useCmodelMutations} from "../../api/cmodelsapi";
import React, {useCallback} from "react";
import {BMODELS_EMPTY} from "../../api/bmodelsapi";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {FormControlCustom} from "../controls/FormControls";
import {Bounce, toast} from "react-toastify";
import {pdf, PDFViewer} from "@react-pdf/renderer";
import {ModelCPdf} from "../formpdf/ModelCPdf";
import {ModelBPdf} from "../formpdf/ModelBPdf";
import {useFileMutations} from "../../api/fileapi";
import {useEmailMutations} from "../../api/emailapi";
import {ModelDPdf} from "../formpdf/ModelDPdf";
import {DMODELS_EMPTY} from "../../api/dmodelsapi";
import {minioBaseUrl} from "../../data/defaultConfig";

export function CmodelForm(props) {
    const {onOpenChanged, onItemEditingChanged, itemEditing} = props;
    const {createCmodel, editCmodel} = useCmodelMutations();
    const {uploadFile} = useFileMutations();
    const {createFormEmail} = useEmailMutations();
    const initialObjectInintializer = useCallback(() => itemEditing ? itemEditing : BMODELS_EMPTY, [])
    const {onChange, tempObject, onEditorChange} = useForm(initialObjectInintializer);
    const notify = (message, type) => {
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: type,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    async function handleCreate(event) {
        event.preventDefault();
        const response = await createCmodel({
            ...tempObject,
            datumOpstelling: (new Date().toISOString())
        });
        if (response) {
            notify('Model C is verzonden.', 'success');
            const blob = await pdf(ModelCPdf({modelCTempObject: tempObject})).toBlob();
            const pdfFile = new File([blob], `modelC-${new Date().toISOString().substring(0, 10)}${new Date().getMinutes()}${new Date().getMilliseconds()}.pdf`);
            const uploadFileResult = await uploadFile({file: pdfFile});
            if (uploadFileResult) {
                const newEmail = {
                    title: "VBFlw, Nieuw Model C formulier ingevuld",
                    emailto: '',
                    emailfrom: "administratie@vbflw.be",
                    description: `
                    <p>Automatisch bericht van de VBFlw website:</p>
                    <p>Er is een Model C formulier ingevuld.</p>
                    <a href="${minioBaseUrl + uploadFileResult.url}">Click hier voor de pdf te downloaden</a>
                    `,
                    attachment: uploadFileResult.id
                };
                const emailResult = await createFormEmail(newEmail);
                if (emailResult) window.location.reload();
            }
        }
        if (!response) notify('Fout bij het verzenden. Probeer het later nog eens.', 'error');
    }

    async function handleEdit(e) {
        const result = await editCmodel(tempObject);
        if (result) {
            onItemEditingChanged(undefined);
            onOpenChanged(false);
        }
    }

    const formComplete =
        tempObject.provincie &&
        tempObject.sector &&
        tempObject.sectornr &&
        tempObject.naamVoornaamVoorzitter &&
        tempObject.straatNrVoorzitter &&
        tempObject.postnrVoorzitter &&
        tempObject.telgsmemailVoorzitter &&
        tempObject.naamVoornaamSecretaris &&
        tempObject.straatNrSecretaris &&
        tempObject.postnrSecretaris &&
        tempObject.telgsmemailSecretaris &&
        tempObject.naamVoornaamPenningsmeester &&
        tempObject.straatNrPenningsmeester &&
        tempObject.postnrPenningsmeester &&
        tempObject.telgsmemailPenningsmeester;
    return <Form>
        <Section>
            <Section className={'mb-2'}>

                <Col xs={4}>
                    <FormControlCustom title={'Provincie*'} value={tempObject.provincie} filled={tempObject.provincie}
                                       onChange={e => onChange(e, 'provincie')}/>
                </Col>
                <Col xs={4}>
                    <FormControlCustom title={'Sector*'} value={tempObject.sector} filled={tempObject.sector}
                                       onChange={e => onChange(e, 'sector')}/>
                </Col>
                <Col xs={4}>
                    <FormControlCustom title={'SectorNr*'} value={tempObject.sectornr} filled={tempObject.sectornr}
                                       onChange={e => onChange(e, 'sectornr')}/>
                </Col>


            </Section>
            <hr/>

            <Section className={'mb-2'}>
                <Col xs={2}>
                    Voorzitter
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={12}>
                            <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamVoorzitter}
                                               filled={tempObject.naamVoornaamVoorzitter}
                                               onChange={e => onChange(e, 'naamVoornaamVoorzitter')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrVoorzitter}
                                               filled={tempObject.straatNrVoorzitter}
                                               onChange={e => onChange(e, 'straatNrVoorzitter')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrVoorzitter}
                                               filled={tempObject.postnrVoorzitter}
                                               onChange={e => onChange(e, 'postnrVoorzitter')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailVoorzitter}
                                               filled={tempObject.telgsmemailVoorzitter}
                                               onChange={e => onChange(e, 'telgsmemailVoorzitter')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>
            <hr/>
            <Section>
                <Col xs={2}>
                    Secretaris
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={12}>
                            <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamSecretaris}
                                               filled={tempObject.naamVoornaamSecretaris}
                                               onChange={e => onChange(e, 'naamVoornaamSecretaris')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrSecretaris}
                                               filled={tempObject.straatNrSecretaris}
                                               onChange={e => onChange(e, 'straatNrSecretaris')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrSecretaris}
                                               filled={tempObject.postnrSecretaris}
                                               onChange={e => onChange(e, 'postnrSecretaris')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailSecretaris}
                                               filled={tempObject.telgsmemailSecretaris}
                                               onChange={e => onChange(e, 'telgsmemailSecretaris')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>
            <hr/>

            <Section>
                <Col xs={2}>
                    Penningsmeester
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={12}>
                            <FormControlCustom title={'Naam, Voornaam*'} value={tempObject.naamVoornaamPenningsmeester}
                                               filled={tempObject.naamVoornaamPenningsmeester}
                                               onChange={e => onChange(e, 'naamVoornaamPenningsmeester')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Straat, nr*'} value={tempObject.straatNrPenningsmeester}
                                               filled={tempObject.straatNrPenningsmeester}
                                               onChange={e => onChange(e, 'straatNrPenningsmeester')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Postnr, Gemeente*'} value={tempObject.postnrPenningsmeester}
                                               filled={tempObject.postnrPenningsmeester}
                                               onChange={e => onChange(e, 'postnrPenningsmeester')}/>
                        </Col>
                        <Col xs={12}>
                            <FormControlCustom title={'Tel/Gsm/Email*'} value={tempObject.telgsmemailPenningsmeester}
                                               filled={tempObject.telgsmemailPenningsmeester}
                                               onChange={e => onChange(e, 'telgsmemailPenningsmeester')}/>
                        </Col>
                    </Section>
                </Col>
            </Section>
            <hr/>
            <Section>
                <Col xs={2}>
                    Raadsleden
                </Col>
                <Col xs={10}>
                    <Section>
                        <Col xs={12}>
                            <FormLabel>Naam, Voornaam</FormLabel>
                            <FormControl value={tempObject.naamVoornaamRaadsLid1}
                                         onChange={e => onChange(e, 'naamVoornaamRaadsLid1')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Straat, nr</FormLabel>
                            <FormControl value={tempObject.straatNrRaadsLid1}
                                         onChange={e => onChange(e, 'straatNrRaadsLid1')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Postnr, Gemeente</FormLabel>
                            <FormControl value={tempObject.postNrGemeenteRaadsLid1}
                                         onChange={e => onChange(e, 'postNrGemeenteRaadsLid1')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Tel/Gsm/Email</FormLabel>
                            <FormControl value={tempObject.telGsmEmailRaadsLid1}
                                         onChange={e => onChange(e, 'telGsmEmailRaadsLid1')}/>
                        </Col>
                    </Section>
                    <hr/>
                    <Section>
                        <Col xs={12}>
                            <FormLabel>Naam, Voornaam</FormLabel>
                            <FormControl value={tempObject.naamVoornaamRaadsLid2}
                                         onChange={e => onChange(e, 'naamVoornaamRaadsLid2')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Straat, nr</FormLabel>
                            <FormControl value={tempObject.straatNrRaadsLid2}
                                         onChange={e => onChange(e, 'straatNrRaadsLid2')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Postnr, Gemeente</FormLabel>
                            <FormControl value={tempObject.postNrGemeenteRaadsLid2}
                                         onChange={e => onChange(e, 'postNrGemeenteRaadsLid2')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Tel/Gsm/Email</FormLabel>
                            <FormControl value={tempObject.telGsmEmailRaadsLid2}
                                         onChange={e => onChange(e, 'telGsmEmailRaadsLid2')}/>
                        </Col>
                    </Section>

                    <hr/>
                    <Section>
                        <Col xs={12}>
                            <FormLabel>Naam, Voornaam</FormLabel>
                            <FormControl value={tempObject.naamVoornaamRaadsLid3}
                                         onChange={e => onChange(e, 'naamVoornaamRaadsLid3')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Straat, nr</FormLabel>
                            <FormControl value={tempObject.straatNrRaadsLid3}
                                         onChange={e => onChange(e, 'straatNrRaadsLid3')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Postnr, Gemeente</FormLabel>
                            <FormControl value={tempObject.postNrGemeenteRaadsLid3}
                                         onChange={e => onChange(e, 'postNrGemeenteRaadsLid3')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Tel/Gsm/Email</FormLabel>
                            <FormControl value={tempObject.telGsmEmailRaadsLid3}
                                         onChange={e => onChange(e, 'telGsmEmailRaadsLid3')}/>
                        </Col>
                    </Section>

                    <hr/>
                    <Section>
                        <Col xs={12}>
                            <FormLabel>Naam, Voornaam</FormLabel>
                            <FormControl value={tempObject.naamVoornaamRaadsLid4}
                                         onChange={e => onChange(e, 'naamVoornaamRaadsLid4')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Straat, nr</FormLabel>
                            <FormControl value={tempObject.straatNrRaadsLid4}
                                         onChange={e => onChange(e, 'straatNrRaadsLid4')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Postnr, Gemeente</FormLabel>
                            <FormControl value={tempObject.postNrGemeenteRaadsLid4}
                                         onChange={e => onChange(e, 'postNrGemeenteRaadsLid4')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Tel/Gsm/Email</FormLabel>
                            <FormControl value={tempObject.telGsmEmailRaadsLid4}
                                         onChange={e => onChange(e, 'telGsmEmailRaadsLid4')}/>
                        </Col>
                    </Section>

                    <hr/>
                    <Section>
                        <Col xs={12}>
                            <FormLabel>Naam, Voornaam</FormLabel>
                            <FormControl value={tempObject.naamVoornaamRaadsLid5}
                                         onChange={e => onChange(e, 'naamVoornaamRaadsLid5')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Straat, nr</FormLabel>
                            <FormControl value={tempObject.straatNrRaadsLid5}
                                         onChange={e => onChange(e, 'straatNrRaadsLid5')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Postnr, Gemeente</FormLabel>
                            <FormControl value={tempObject.postNrGemeenteRaadsLid5}
                                         onChange={e => onChange(e, 'postNrGemeenteRaadsLid5')}/>
                        </Col>
                        <Col xs={12}>
                            <FormLabel>Tel/Gsm/Email</FormLabel>
                            <FormControl value={tempObject.telGsmEmailRaadsLid5}
                                         onChange={e => onChange(e, 'telGsmEmailRaadsLid5')}/>
                        </Col>
                    </Section>
                    {itemEditing ? <Col xs={6} className={'p-1'}>
                        <Section>
                            <Col xs={12}>
                                <FormLabel htmlFor={'vzwjn'}>Verwerkt? </FormLabel>
                            </Col>
                            <Col xs={'auto'}>
                                <LabelWithInput title={'ja'}> <FormCheck id={'verwerktja'}
                                                                         defaultChecked={tempObject.verwerkt}
                                                                         name={'verwerkt'} value={"true"} type={'radio'}
                                                                         onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>

                            </Col>
                            <Col xs={'auto me-2'}>
                                <LabelWithInput title={'nee'}> <FormCheck id={'verwerktnee'}
                                                                          defaultChecked={!tempObject.verwerkt}
                                                                          name={'verwerkt'}
                                                                          value={"false"} type={'radio'}
                                                                          onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>
                            </Col>
                        </Section>
                    </Col> : ''}
                </Col>
            </Section>
            <Col xs={12} className={'text-end mt-2'}>
                <Button disabled={!formComplete}
                        onClick={e => itemEditing ? handleEdit(e) : handleCreate(e)}>{!formComplete ? 'Nog niet alle verplichte * velden zijn ingevuld!' : 'Submit'}</Button>
            </Col>
        </Section>
    </Form>
}